const frameName = !!process.env.REACT_APP_FRAME_NAME ? process.env.REACT_APP_FRAME_NAME.toLowerCase() : '__';
let PREFIX = `commandbar.${frameName}`;
if (['commandbar', 'proxy'].includes(frameName)) {
    //  backwards compatibility
    PREFIX = 'commandbar';
}
const set = (label, value) => {
    try {
        localStorage.setItem(`${PREFIX}.${label}`, value.toString());
        return value;
    }
    catch (err) {
        return '';
    }
};
const get = (label, defaultValue) => {
    let value;
    try {
        value = localStorage.getItem(`${PREFIX}.${label}`);
    }
    catch (err) {
        value = null;
    }
    if (value === null) {
        return defaultValue;
    }
    else {
        if (value === 'false')
            return false;
        if (value === 'true')
            return true;
        if (+value)
            return +value;
        return value;
    }
};
const remove = (label) => {
    try {
        localStorage.removeItem(`${PREFIX}.${label}`);
        return;
    }
    catch (err) {
        return;
    }
};
const LocalStorage = {
    set,
    get,
    remove,
};
export default LocalStorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9jYWxTdG9yYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3V0aWwvTG9jYWxTdG9yYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFNBQVMsR0FBRyxDQUFDLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDO0FBQzdHLElBQUksTUFBTSxHQUFHLGNBQWMsU0FBUyxFQUFFLENBQUM7QUFDdkMsSUFBSSxDQUFDLFlBQVksRUFBRSxPQUFPLENBQUMsQ0FBQyxRQUFRLENBQUMsU0FBUyxDQUFDLEVBQUU7SUFDL0MsMkJBQTJCO0lBQzNCLE1BQU0sR0FBRyxZQUFZLENBQUM7Q0FDdkI7QUFFRCxNQUFNLEdBQUcsR0FBRyxDQUFDLEtBQWEsRUFBRSxLQUFnQyxFQUFFLEVBQUU7SUFDOUQsSUFBSTtRQUNGLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxNQUFNLElBQUksS0FBSyxFQUFFLEVBQUUsS0FBSyxDQUFDLFFBQVEsRUFBRSxDQUFDLENBQUM7UUFDN0QsT0FBTyxLQUFLLENBQUM7S0FDZDtJQUFDLE9BQU8sR0FBRyxFQUFFO1FBQ1osT0FBTyxFQUFFLENBQUM7S0FDWDtBQUNILENBQUMsQ0FBQztBQUVGLE1BQU0sR0FBRyxHQUFHLENBQUMsS0FBYSxFQUFFLFlBQXVDLEVBQUUsRUFBRTtJQUNyRSxJQUFJLEtBQUssQ0FBQztJQUNWLElBQUk7UUFDRixLQUFLLEdBQUcsWUFBWSxDQUFDLE9BQU8sQ0FBQyxHQUFHLE1BQU0sSUFBSSxLQUFLLEVBQUUsQ0FBQyxDQUFDO0tBQ3BEO0lBQUMsT0FBTyxHQUFHLEVBQUU7UUFDWixLQUFLLEdBQUcsSUFBSSxDQUFDO0tBQ2Q7SUFFRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDbEIsT0FBTyxZQUFZLENBQUM7S0FDckI7U0FBTTtRQUNMLElBQUksS0FBSyxLQUFLLE9BQU87WUFBRSxPQUFPLEtBQUssQ0FBQztRQUNwQyxJQUFJLEtBQUssS0FBSyxNQUFNO1lBQUUsT0FBTyxJQUFJLENBQUM7UUFDbEMsSUFBSSxDQUFDLEtBQUs7WUFBRSxPQUFPLENBQUMsS0FBSyxDQUFDO1FBQzFCLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7QUFDSCxDQUFDLENBQUM7QUFFRixNQUFNLE1BQU0sR0FBRyxDQUFDLEtBQWEsRUFBUSxFQUFFO0lBQ3JDLElBQUk7UUFDRixZQUFZLENBQUMsVUFBVSxDQUFDLEdBQUcsTUFBTSxJQUFJLEtBQUssRUFBRSxDQUFDLENBQUM7UUFDOUMsT0FBTztLQUNSO0lBQUMsT0FBTyxHQUFHLEVBQUU7UUFDWixPQUFPO0tBQ1I7QUFDSCxDQUFDLENBQUM7QUFFRixNQUFNLFlBQVksR0FBRztJQUNuQixHQUFHO0lBQ0gsR0FBRztJQUNILE1BQU07Q0FDUCxDQUFDO0FBRUYsZUFBZSxZQUFZLENBQUMifQ==